import common from '../common'
/**
 * @param base64String 图片地址
 * @param judge 0 分享好友  1 分享朋友圈
 * WxImageShare(String base64String, int judge)
 */
const wxImageShare = (imgBlobData, index) => {
    if( !imgBlobData ) {
        return
    }
    // 安卓
    if( !common?.isAndroid_ios() ) {
        window.androidNative.WxImageShare(imgBlobData, index * 1)
    }else {
        if( window?.webkit?.messageHandlers?.WxImageShare) {
            window?.webkit.messageHandlers.WxImageShare.postMessage({
                imgBlobData:imgBlobData || '',
                index: index || 0
            })
        }
    }
}
export default wxImageShare